import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { FormFunctions } from 'src/app/shared/form-components/form-functions';
import { OtherCoreBusinessActivitiesFunctions } from './other-core-business-activities.functions';


@Component({
  selector: 'app-other-core-business-activities',
  templateUrl: './other-core-business-activities.component.html',
  styleUrls: ['./other-core-business-activities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class OtherCoreBusinessActivitiesComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() logPrefix?: string;
  @Input() routerUrl?: string;
  @Input() formGroup?: UntypedFormGroup;
  @Input() propertyId?: string;
  @Input() isVehicleCu?: boolean = false;
  
  
  subscriptions: Subscription[] = [];   
  
  constructor(  
    public formFunctions: FormFunctions,
    private otherCoreBusinessActivitiesFunctions: OtherCoreBusinessActivitiesFunctions) { }

  ngOnInit() {   
    
   }

  ngAfterViewInit() { }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  private unsubscribeAll() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }

  
  updateVehicleOwnedOrLeased(value: string) { 
    this.otherCoreBusinessActivitiesFunctions.updateVehicleOwnedOrLeased(value, this.formGroup);
  } 

  addNewModelOrYear(){ 
    this.otherCoreBusinessActivitiesFunctions.addNewModelOrYear(this.formGroup);
  }

  removeModelAndYear(index: number){
    this.otherCoreBusinessActivitiesFunctions.removeModelAndYear(index, this.formGroup);
  }     
}
